import { FlexRow, useTranslate } from '@synqo/frontend-component-library';
import styles from './ContainerActions.module.css';

/** What the container card shows while the order plans no container. */
// @ai-generated 2026-10-15T12:08:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function ContainerEmptyState() {
    const i18n = useTranslate('');

    return <FlexRow className={styles.emptyState}>{i18n('Keine Container.')}</FlexRow>;
}
